import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=758cc4e0&scoped=true&"
import script from "./EllipsisText.vue?vue&type=script&lang=js&"
export * from "./EllipsisText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758cc4e0",
  null
  
)

export default component.exports